import Subscriptions from "./Subscriptions";
import Services from "./services/Services";

export const subscriptionKeys = {
  referenceChanged: "configuration-reference-changed"
};

class CoreConfiguration {
  constructor() {
    this.hooks = {
      pivot: {
        filterRefer: null,
        filterRespond: null,
        customActions: null,
        customDetails: null
      },
      notification: null,
      display: {
        barFormat: null
      },
      theme: {
        changed: null
      }
    };

    this.options = {
      display: {
        zIndex: 9000
      },
      pivot: {
        disableRefer: false,
        disableRespond: false,
        modalPortal: window.document && window.document.body
      },
      finder: {
        ignoreHidden: false
      }
    };

    this.references = {
      productTheme: null,
      appRootElement: window.document && window.document.body
    };

    this.components = {
      Notifier: null
    };
  }

  setHooks(key, hooks) {
    if (!Object.keys(this.hooks).includes(key)) {
      console.warn(`${key} is not a valid hook set`);
      return;
    }

    if (typeof hooks === "function") {
      this.hooks[key] = hooks;
    } else {
      const keys = Object.keys(hooks);
      keys.forEach(k => {
        this.hooks[key][k] = hooks[k];
      });
    }
  }

  setOptions(key, options) {
    if (key === "services") {
      Services.hasRetryInterceptor = options.hasRetryInterceptor;

      return;
    }

    if (!Object.keys(this.options).includes(key)) {
      console.warn(`${key} is not a valid options set`);
      return;
    }

    const optionKeys = Object.keys(options);

    optionKeys.forEach(k => {
      const option = options[k];

      this.options[key][k] = option;
    });
  }

  setReference(key, reference) {
    if (!Object.keys(this.references).includes(key)) {
      console.warn(`${key} is not a valid reference`);
      return;
    }

    this.references[key] = reference;

    Subscriptions.publish(subscriptionKeys.referenceChanged, {key, reference});
  }

  setComponent(key, component) {
    if (!Object.keys(this.components).includes(key)) {
      console.warn(`${key} is not a valid component`);
      return;
    }

    this.components[key] = component;
  }

  setEngine(key, value) {
    if (!Object.keys(this.engine).includes(key)) {
      console.warn(`${key} is not a valid reference`);
      return;
    }

    this.engine[key] = value;
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonCore) {
    window.atsSecurityRibbonCore = new CoreConfiguration();
  }
  return window.atsSecurityRibbonCore;
};

export default Configuration();
